import ResourceStore from "../../../shared/services/ResourceStore";

class InvoiceStore extends ResourceStore {
  _baseUrl (_params) {
    return "/api/v4";
  }

  async fetchReceipt (hash) {
    let response = await fetch(`/api/v4/invoices/${hash}/receipt`, {
      method: "GET"
    });

    const responseJSON = await response.json();

    return responseJSON;
  }

  async fetchPayout (hash) {
    let response = await fetch(`/api/v4/invoices/${hash}/payout`, {
      method: "GET"
    });

    const responseJSON = await response.json();

    return responseJSON;
  }

  async voidInvoice (invoiceId) {
    let response = await fetch(`/api/v4/invoices/${invoiceId}/void`, {
      method: "PATCH"
    });

    const responseJSON = await response.json();

    return responseJSON;
  }
};

export default new InvoiceStore("invoice");
